// libs
import React from 'react';

// components
import { Box } from '@lyearn/ui';

import Order from './components/Order';
import ScoreBox from './components/ScoreBox';
import Title from './components/Title';
// types
import { QuestionProps } from './types';

function QuestionPreview({ question, className }: QuestionProps) {
  const { id, text, order, maxScore } = question;

  return (
    <Box className={className}>
      <Order order={order} />
      <Title className="mb-8 xs:mb-12" title={text} variant="label-01" />
      <ScoreBox maxScore={maxScore} questionId={id} />
    </Box>
  );
}

export default React.memo(QuestionPreview);
